import { Routes, Route, Navigate } from "react-router-dom";

import Distributions from "./Distributions";

const distributionsRoutes = [
    {routeName: 'primary-distribution' , component: <Distributions/>},
    {routeName: 'secondary-distribution' , component: <Distributions/>},
    {routeName: 'inventory-management' , component: <Distributions/>},
    {routeName: 'warehousing' , component: <Distributions/>},
];

const DistributionsRoutes = () => {
    return (
    <Routes>
       {distributionsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default DistributionsRoutes;